import type { TeamsApi } from "@/v2/api/metadata/teams";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { teamGamesStatusOptions } from "../../../../shared";
import { notifySuccess, teamId } from "../shared";

const liveTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "liveGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: teamGamesStatusOptions,
        inheritance: { computedKey: "computedStatus", parentKey: "parentStatus" },
      },
    ],
  },
];

export function createLiveTab(teamsApi: TeamsApi): ContentTab {
  return {
    id: "live",
    label: "Live",
    save: createInheritableTabSave({
      children: liveTabChildren,
      persist: async (patch, ctx: DialogTabSaveContext) => {
        await teamsApi.update(teamId(ctx.values), patch);
        notifySuccess();
      },
    }),
    children: liveTabChildren,
  };
}
